import { FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Revisione53State } from '../../../store/revisione53.reducers';
import { withChangeDebounced } from '@shared/operators/with-change-debounced.operator';
import { updateVerbaleOnStore } from '@core/helpers/create-validator.helper';
import { MyVerbale } from '../../../models/interfaces/revisione.interface';
import { buildContrib59Name, getContribLegge59Control } from '../validators/helpers/contrib-legge-59-92-form.helpers';
import { cloneDeep } from 'lodash-es';
import { isNilOrEmpty } from '@shared/helpers/utils.helper';

export const setContribLegge59FondoBeneficiarioListeners = (form: FormGroup, store: Store<Revisione53State>): void => {
    const flags = [false, true];
    flags.forEach((flag) => {
        my_FondoBeneficiarioHelper(form, store, flag);
        my_CkTipoFondoBenHelper(form, store, flag);
    });
};

const my_FondoBeneficiarioHelper = (form: FormGroup, store: Store<Revisione53State>, isFirstYear: boolean): void => {
    const my_FondoBeneficiarioControl = getContribLegge59Control(form, buildContrib59Name('my_FondoBeneficiario', isFirstYear));
    const my_CkTipoFondoBenControl = getContribLegge59Control(form, buildContrib59Name('my_CkTipoFondoBen', isFirstYear));

    my_FondoBeneficiarioControl.valueChanges.pipe(withChangeDebounced(my_FondoBeneficiarioControl)).subscribe(() => {
        updateVerbaleOnStore(store, (myVerbale) => {
            const myVerbaleClone: MyVerbale = cloneDeep(myVerbale);
            const my_CkTipoFondoBenValue = ((my_FondoBeneficiarioControl.value as string) ?? '').includes('MiSE') ? '1' : '0';
            myVerbaleClone.my_SezioneI__Rilevazione.my_ContributoLegge59[buildContrib59Name('my_CkTipoFondoBen', isFirstYear)] = my_CkTipoFondoBenValue;
            my_CkTipoFondoBenControl.patchValue(my_CkTipoFondoBenValue, { emitEvent: false });
            return myVerbaleClone;
        });
    });
};

const my_CkTipoFondoBenHelper = (form: FormGroup, store: Store<Revisione53State>, isFirstYear: boolean): void => {
    const my_CkTipoFondoBenControl = getContribLegge59Control(form, buildContrib59Name('my_CkTipoFondoBen', isFirstYear));

    my_CkTipoFondoBenControl.valueChanges.pipe(withChangeDebounced(my_CkTipoFondoBenControl)).subscribe(() => {
        const newFondoBeneficiario = setMise(form, buildContrib59Name('my_CkTipoFondoBen', isFirstYear), buildContrib59Name('my_FondoBeneficiario', isFirstYear));
        updateVerbaleOnStore(store, (myVerbale) => {
            const myVerbaleClone: MyVerbale = cloneDeep(myVerbale);
            myVerbaleClone.my_SezioneI__Rilevazione.my_ContributoLegge59[buildContrib59Name('my_FondoBeneficiario', isFirstYear)] = newFondoBeneficiario;
            return myVerbaleClone;
        });
    });
};

const setMise = (form: FormGroup, check: string, text: string): string => {
    const checkControl = getContribLegge59Control(form, check);
    const textControl = getContribLegge59Control(form, text);
    const stripped = ((textControl.value as string) ?? '').replace('MiSE', '').trim();
    const textReplaced = checkControl.value === '1' ? `MiSE ${stripped}`.trim() : stripped;
    const newValue = !isNilOrEmpty(textReplaced) ? textReplaced : '';
    textControl.patchValue(newValue, { emitEvent: false });
    return newValue;
};
